import { render, staticRenderFns } from "./screening-history.vue?vue&type=template&id=18e13ba0&"
import script from "./screening-history.vue?vue&type=script&lang=js&"
export * from "./screening-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports